import { render, staticRenderFns } from "./PcList.vue?vue&type=template&id=64bd452e&scoped=true"
import script from "./PcList.vue?vue&type=script&lang=ts"
export * from "./PcList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd452e",
  null
  
)

export default component.exports